import wura_poster from "../../Assets/wura.jpg";
import wande_poster from "../../Assets/wande.jpg";
import mayokun_poster from "../../Assets/mayokun.jpg";

export const heroData = [{
    poster:wura_poster,
    quote:`I've become more conscious of how I 
    spend my money and also about 
    investing. Now, I feel comfortable 
    spending knowing my Cowrywise account is there.`,
    author:"Wuraola F",
    username:"@wuwu",
    backgroundColor:"#f0ced4"
  },{
    poster:mayokun_poster,
    quote:`Cowrywise makes saving quite
     interesting and fun. My best part would 
     be the fact that I can seamlessly invest my naira in dollars.`,
     author:"Mayokun A",
     username:"@mhay",
     backgroundColor:"#cbede8"
  },{
    poster:wande_poster,
    quote:`
    I love how Cowrywise has made me think 
    of saving part of any income I get.
     I immediately think of investing any money I get now.
    `,
    author:"Olaitan O",
    username:'@thevideopilot',
    backgroundColor:"#98bce5"
  }];

export const footer = [
  {
                 heading: 'Company',
                 list: ['About us',
                          'Peers',
                          'Career',
                          'Ambassadors',
                          'Complaints Management',
                          'Privacy',
                          'Terms',
                 ]
                },
                 {
                 heading: 'Product',
                 list: ['Saving Plans',
                          'Investment Plans',
                          'Mutual Funds',
                          'Embed API',
                          'Sprouts',
                          'Halal',
                          'Get a suggestion?',
                 ]},
                 {
                 heading: 'Resources',
                 list: ['Customer Stories',
                          'Media',
                          'FAQs',
                          'Security',
                          'Estimate your Interest',
                          'Plan Education',
                          'Engineering',
                          'Glossary',
                          'Blog',
                          'Help Center'
                 ]},
                  {
                 heading: 'Contact',
                 list: ['support@cowrywise.com',
                          'WhatsApp ↗',
                          
                       
                 ]},
            ]

